import { getUnitSymbols, LinearUnit, UnitSymbols } from '../utils/proj4/units';

/**
 * Minimal bridge for viewer (ThreeJS) code to access app-provided environment data (React-owned).
 * React code should call setSpatialReference() when coordinate system / geoid change.
 */
type SpatialReference = {
  projection?: string;
  projectionName?: string;
  geoid?: string | null;
  linearUnit?: LinearUnit;
};

type Listener = (spatialRef: SpatialReference) => void;

class ViewerEnvironment {
  private spatialRef: SpatialReference = {};
  private listeners = new Set<Listener>();

  setSpatialReference(spatialRef: SpatialReference) {
    this.spatialRef = { ...spatialRef };
    this.listeners.forEach((l) => l(this.spatialRef));
  }

  getSpatialReference(): SpatialReference {
    return { ...this.spatialRef };
  }

  /** The length, area and volume symbols for the project's coordinate system. */
  getUnitSymbols(): UnitSymbols {
    return getUnitSymbols(this.spatialRef.linearUnit ?? 'm');
  }

  subscribeSpatialReference(listener: Listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const ViewerEnvironmentInstance = new ViewerEnvironment();
